// extracted by mini-css-extract-plugin
export var closeButton = "_3m-3";
export var header = "_3m-0";
export var link = "_3m-1";
export var retryButton = "_3m-2";